import { render, staticRenderFns } from "./LineNotification.vue?vue&type=template&id=9cd87538&scoped=true&"
import script from "./LineNotification.vue?vue&type=script&lang=js&"
export * from "./LineNotification.vue?vue&type=script&lang=js&"
import style0 from "./LineNotification.vue?vue&type=style&index=0&id=9cd87538&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd87538",
  null
  
)

export default component.exports